/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgUnit = {
  header: 'Todas as unidades ({{count}})',
  unit: 'Unidade',
  name: 'Nome',
  uid: 'Código',
  approvalProcess: 'Processo de aprovação',
  parentUnit: 'Unidade padre',
  active: 'Estado',
  hint: 'As unidades representam departamentos, lojas, regiões ou qualquer outro agrupamento lógico que faça sentido para você. Os centros de custo e os endereços de remessa disponíveis para um comprador no momento da compra dependem de sua unidade. Os usuários têm acesso a todas as unidades secundárias em sua unidade pai.',
  details: {
    title: 'Detalhes da unidade',
    subtitle: 'Unidade: {{ item.name }}',
    hint: 'As unidades representam departamentos, lojas, regiões ou qualquer outro agrupamento lógico que faça sentido para você. A desativação de uma unidade desativa todos os filhos da unidade, incluindo unidades filhas, usuários, aprovadores e centros de custo. As unidades desativadas não podem ser editadas.',
  },
  edit: {
    title: 'Edit Unidade',
    subtitle: 'Unidade: {{ item.name }}',
  },
  create: {
    title: 'Criar Unidade',
    subtitle: '',
  },

  messages: {
    deactivateTitle: 'Disable esta unidade?',
    deactivate: `A desativação de uma unidade tem efeitos de longo alcance em sua organização comercial. TODAS as unidades filhas, usuários, orçamentos e centros de custo na unidade também serão desabilitados.`,
    confirmEnabled: 'Unidade {{item.name}} ativada com sucesso',
    confirmDisabled: 'Unidade {{item.name}} desativada com sucesso',
    update: 'Unidade {{ item.name }} atualizada com sucesso',
    create: 'Unidade {{ item.name }} criada com sucesso',
  },
  info: {
    disabledEdit: 'Ative a unidade para permitir a edição.',
    disabledEnable: 'O pai deve ser habilitado antes que esta unidade possa ser habilitada.',
    disabledDisable: 'A unidade raiz não pode ser desativada.',
  },

  links: {
    units: 'Filhas unidas:',
    users: 'Usuários',
    approvers: 'Aprovadores',
    shippingAddresses: 'Endereços de entrega',
    costCenters: 'Centros de custódia',
  },

  tree: {
    expandAll: 'Expandir tudo',
    collapseAll: 'Recolher tudo',
    expand: 'Expandir',
    collapse: 'colapso',
  },

  children: {
    create: {
      title: 'Criar unidade secundária',
      subtitle: '',
    },
    messages: {
      create: 'Unidade {{ item.name }} criada com sucesso',
    },
  },

  costCenters: {
    create: {
      title: 'Criar centro de custo',
      subtitle: '',
    },
  },

  form: {
    parentOrgUnit: 'Unidade de negocio matriz',
    create: 'Criar Unidade',
    parentOrgUnitNotes:
      'Essa unidade é a unidade de nível superior da sua organização. Não pode ser atribuído a outra unidade.',
  },
  users: {
    header: 'Usuários in {{code}}',
    changeUserRoles: 'Alterar funções de usuário',
    newUser: 'Novo usuário',
  },
  assignRoles: {
    header: 'Gerenciar funções em {{{code}}',
    instructions: {
      check: "Para atribuir uma função a um usuário, marque a caixa de seleção função.",
      uncheck: "Para excluir uma função, desmarque a caixa de seleção da função.",
      changes: 'As alterações são salvas automaticamente.',
    },
  },
  approvers: {
    header: 'Aprovadores in {{code}}',
    assign: 'Gerenciando aprovadores',
    new: 'Novo aprovador',
  },
  assignApprovers: {
    header: 'Gerenciando aprovadores in {{code}}',
    instructions: {
      check: "Para atribuir um aprovador a esta unidade, marque a caixa de seleção do usuário.",
      uncheck: "Para remover um aprovador, desmarque a caixa de seleção do usuário.",
      changes: 'As alterações são salvas automaticamente.',
    },
    hint: "Os usuários mostrados na lista Aprovadores recebem privilégios de aprovação para compradores dessa unidade e das unidades filhas. Observe que um usuário que tem a função de Aprovador é separado de um aprovador listado na lista Aprovadores. Se um aprovador não existir para uma unidade ou se os aprovadores não tiverem privilégios de compra de aprovação suficientes, um aprovador estará localizado mais acima na hierarquia da unidade, até que uma administração seja escolhida.",
  },

  breadcrumbs: {
    list: 'Todas as unidades',
    details: '{{name}}',
    children: 'Unidades Secundárias',
    users: 'Usuários',
    approvers: 'Aprovadores',
    addresses: 'Endereços de entrega',
    addressDetails: '{{{formattedAddress}}',
    costCenters: 'Centros de custódia',
  },
};

export const orgUnitChildren = {
  title: 'Unidades Secundárias',
  subtitle: 'Unidade: {{item.name}}',
  info: {
    disabledCreate: 'Não é possível criar uma unidade secundária para uma unidade desativada.',
  },
  hint: 'Unidades represent departments, stores, regions, or any other logical grouping that makes sense to you. Usuários "inherit" child units, meaning buyers have access to cost centers and delivery addresses of child units when checking out.',
};

export const orgUnitAssignedRoles = {
  header: 'Gerenciar funções em {{code}}',
  name: 'Nome',
  email: 'Email',
  roles: 'Papéis',
  roleCustomer: 'Cliente',
  roleApprover: 'Aprovador',
  roleManager: 'Diretor',
  roleAdministrator: 'Admin',
};

export const orgUnitApprovers = {
  title: 'Gerenciando aprovadores',
  subtitle: 'Unidade: {{item.name}}',
  assigned: 'Usuário {{item.name}} Atribuído corretamente',
  unassigned: 'Usuário {{item.name}} não atribuído corretamente',
};

export const orgUnitAssignedApprovers = {
  title: 'Aprovadores atribuídos',
  subtitle: 'Unidade: {{item.name}}',
  assigned: 'Usuário {{item.name}} Atribuído corretamente',
  unassigned: 'Usuário {{item.name}} não atribuído corretamente',
  hint: "Os usuários mostrados na lista Aprovadores recebem privilégios de aprovação para compradores dessa unidade e das unidades filhas. Observe que um usuário que tem a função de Aprovador é separado de um aprovador listado na lista Aprovadores. Se um aprovador não existir para uma unidade ou se os aprovadores não tiverem privilégios de compra de aprovação suficientes, um aprovador estará localizado mais acima na hierarquia da unidade, até que uma administração seja escolhida.",
};

export const orgUnitAssignedUsers = {
  title: 'Usuários asignados',
  subtitle: 'Unidade: {{item.name}}',
};

export const orgUnitUsers = {
  title: 'Usuários asignados',
  subtitle: 'Unidade: {{item.name}}',
  info: {
    disabledCreate: 'Não é possível criar um usuário para a unidade desativada.',
  },
  hint: 'Usuários are the buyers, approvers, managers, and administrators of your organization. Each user is assigned a role for making or approving purchases. Usuários "inherit" child units, meaning buyers have access to cost centers and delivery addresses of child units when checking out.',
};

export const orgUnitUserRoles = {
  title: 'Funções e direitos do usuário',
  subtitle: 'Usuário: {{item.name}}',
  messages: {
    rolesUpdated: 'Permissões atualizadas com sucesso por {{item.name}}',
  },
};

export const orgUnitCostCenters = {
  title: 'Centros de custódia atribuídos',
  subtitle: 'Unidade: {{item.name}}',
  info: {
    disabledCreate: 'Não é possível criar um centro de custo para a unidade desabilitada.',
  },
  hint: 'All orders placed through your organization\'s purchase account are linked to a cost center for tracking purposes. A buyer selects a cost center when checking out using the "Account" purchase method. Each unit can have multiple cost centers, but a single cost center can only be assigned to a single unit. To define ultimate spending limits, budgets are assigned to cost centers. ',
};

export const orgUnitAddress = {
  title: 'Endereços de entrega',
  subtitle: 'Unidade: {{item.name}}',

  country: 'País/Región',
  titles: 'Título',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  formattedAddress: 'Endereço',
  address1: 'Endereço',
  address2: '2nd address (optional)',
  city: 'Cidade',
  state: 'Estado',
  zipCode: 'Código Postal',
  phoneNumber: 'Número de telefone (opcional)',
  streetAddress: 'Street Endereço',
  aptSuite: 'Apto, Suíte',
  selectOne: 'Selecione um...',

  hint: 'When a buyer is checking out using the "Account" purchase method, they much choose a cost center. The delivery addresses available to the buyer depend on the unit of the cost center chosen.',
  details: {
    title: 'Endereço details',
    subtitle: 'Unidade: {{item.name}}',
  },
  edit: {
    title: 'Edit Endereço',
  },
  create: {
    title: 'Criar Endereço',
  },
  form: {
    subtitle: 'Unidade: {{item.name}}',
  },
  messages: {
    create:
      'Endireitamento {{item.firstName}} criado com sucesso',
    update:
      'Endireitamento {{item.firstName}} atualizado com sucesso',
    delete:
      'O endereço não pode ser recuperado. Os pedidos existentes não são afetados.',
    deleteTitle: 'Excluir este endereço?',
    deleted:
      'Endireitamento {{item.firstName}} {{ item.lastName }} excluído com sucesso',
  },
};
